export const generateMessage = ({ data }) => {
  console.log({ data });
  const {
    services,
    firstName,
    lastName,
    phone,
    email,
    fullDate,
    note,
    time,
    locations,
  } = data;

  const salons = locations.join(", ");

  const formattedNote = `Note(s): ${note}`;

  const formattedClient = `
-- Client Contact -- 
  Name: ${firstName} ${lastName} 
  Phone: ${phone}
  Email: ${email}
  ${note !== "" ? formattedNote : ""}\n`;

  const message = `
      Ms. ${firstName} ${lastName} has just requested a consultation \n
-- Details --
Service(s): ${services.join(", ")}
Available time: ${fullDate} ${time}
Locations preferred: ${salons}
        ${formattedClient}
      `;

  return message;
};

export const getLocationBooking = (record) => {
  const address = !!record?.address ? `${record?.address}` : "";
  const centre = !!record?.centre ? `${record?.centre}` : "";
  const label = `${address}, ${centre}`;
  return label;
};

export const getAddressBooking = (record) => {
  const address = !!record?.address ? `${record?.address}` : "";
  const centre = !!record?.centre ? `${record?.centre}` : "";
  const city = !!record?.city ? `${record?.city}` : "";
  const label = `${address}, ${centre}, ${city}`;
  return label;
};

export const getPhoneLink = (phoneNumber) => {
  // Remove any non-digit characters
  let digits = phoneNumber?.replace(/\D/g, "");

  // Ensure it's the correct length
  if (digits.length === 9) {
    // Insert dashes at the correct positions
    return `tel:${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else {
    throw new Error("Unexpected phone number format");
  }
};
